import {
  Box,
  FormControlLabel,
  Grid,
  InputLabel,
  Typography,
} from "@mui/material";
import { isNil } from "ramda";
import React, { memo } from "react";
import SectionWrapper from "../../../../../common/pageSections/SectionWrapper";
import { Data } from "../../../../../store/terminal/types";
import TerminalReadOnlyFields from "./../../terminalReadOnlyFields/TerminalReadOnlyFields";
import CustomizedCheckbox from "./../../../../../common/formElements/Checkbox";

interface EditTerminalKey {
  terminal: Data | undefined;
  isUpdateAllowed?: boolean;
  isResetSTANAllowed?: boolean;
  bulk: boolean;
  shouldHideField: (fieldName: string) => boolean;
}

const EditTerminalKey = ({ terminal, isUpdateAllowed, isResetSTANAllowed, bulk, shouldHideField }: EditTerminalKey) => {
  const terminalMasterKey = (): boolean =>
    !isNil(terminal?.attributes.TMK1 || terminal?.attributes.TMK2);

  const sessionKeys = (): boolean =>
    isNil(
      terminal?.attributes.TPK ||
        terminal?.attributes.TAKs ||
        terminal?.attributes.TAKr ||
        terminal?.attributes.TEKs ||
        terminal?.attributes.TEKr
    );
  return (
    <Grid container xs={12} spacing={2}>
      <Grid item xs={12} md={6}>
        <FormControlLabel
          control={
            <CustomizedCheckbox checked={terminalMasterKey()} disabled />
          }
          label="Terminal Master Key"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormControlLabel
          control={<CustomizedCheckbox checked={sessionKeys()} disabled />}
          label="Session Keys"
        />
      </Grid>

      <Grid item xs={12}>
        <SectionWrapper isChild title="Manufacturer">
          <Grid container xs={12} spacing={2}>
            <Grid item xs={12} sm={6} md>
              <InputLabel id="manufacturer" shrink>
                Manufacturer
              </InputLabel>
              <Box>
                <Typography>{terminal?.attributes.Manufacturer}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md>
              <InputLabel id="model" shrink>
                Model
              </InputLabel>
              <Box>
                <Typography>{terminal?.attributes.Model}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md>
              <InputLabel id="model-extended" shrink>
                Model Extended
              </InputLabel>
              <Box>
                <Typography>{terminal?.attributes.ModelExtended}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md>
              <InputLabel id="os" shrink>
                Terminal Firmware (OS)
              </InputLabel>
              <Box>
                <Typography>{terminal?.attributes.OS}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md>
              <InputLabel id="installed-docker-firmware" shrink>
                Base Firmware
              </InputLabel>
              <Box>
                <Typography>{terminal?.attributes?.["InstalledDockerFirmware"] || "-"}</Typography>
              </Box>
            </Grid>
          </Grid>
        </SectionWrapper>

        <SectionWrapper isChild title="More Details">
          <TerminalReadOnlyFields terminal={terminal} isResetSTANAllowed={isResetSTANAllowed}/>
        </SectionWrapper>
      </Grid>
    </Grid>
  );
};

export default memo(EditTerminalKey);
